import { render, staticRenderFns } from "./SitchTextEditor.vue?vue&type=template&id=77e90546&"
import script from "./SitchTextEditor.vue?vue&type=script&lang=ts&"
export * from "./SitchTextEditor.vue?vue&type=script&lang=ts&"
import style0 from "./SitchTextEditor.vue?vue&type=style&index=0&id=77e90546&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports